requirejs.config({
    baseUrl: '/v2/js/pwa/app',
    paths: {
        'bootstrap': '../../../lib/bootstrap/js/bootstrap.min',
        'marionette': '../../../lib/marionette/backbone.marionette',
        'backbone': '../../../lib/marionette/backbone',
        'underscore': '../../../lib/marionette/underscore',
        'jquery': '../../../lib/jquery/jquery.min',
        'pwa': '../../../lib/pwa',
        'jquery.cookie': '../../../lib/jquery.cookie',
        'cookieblock': '../../cookieblock',
        'jquery.ui': '../../../lib/jquery-ui-custom/jquery-ui.min',
        'jquery.ui.slider': '../../../lib/jquery-ui-custom/jquery-ui-slider',
        'jquery.ui.touch': '../../../lib/jquery-ui/jquery-ui-touch.amd',
        'handlebars': '../../../lib/marionette/handlebars',
        'marionette.handlebars': '../../../lib/marionette/backbone.marionette.handlebars',
        'utils.string': '../../string',
        'utils.locale': '../../locale',
        'utils.date': '../../date',
        'utils.time': '../../time',
        'less': '../../../lib/less.min',
        'ofi': '../../../lib/ofi.min',
        'notification': '../../../js/push-notifications/push-notifications',
        'promise': '../../../lib/es6-promise.auto.min',
        'assign': '../../../lib/es6-object-assign',
        // external scripts
        'google_adwords': 'https://www.googleadservices.com/pagead/conversion_async',
        'google_analytic': 'https://www.google-analytics.com/analytics',
        'google_translate': 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit',
        //'google.intl.phone': '../../../lib/intl-tel-input/js/utils',
        'google.intl.phone.init': '../../../lib/intl-tel-input/js/intl.initializer',
        'qrcode': '../../../lib/qrcode/qrcode.min',
        'line_liff': 'https://static.line-scdn.net/liff/edge/2/sdk',

        // user_public original sources
        'collection': '../../user_public/app/collection',
        'controller': '../../user_public/app/controller',
        'lib': '../../user_public/app/lib',
        'model': '../../user_public/app/model',
        'module': '../../user_public/app/module',
        'plugin': '../../user_public/app/plugin',
        'view': '../../user_public/app/view',
        'Application': '../../user_public/app/Application',
        'Config': '../../user_public/app/Config',
        'bowser': '../../../lib/es5',

        // pwa sources
        'pwa/collection': 'collection',
        'pwa/controller': 'controller',
        'pwa/lib': 'lib',
        'pwa/model': 'model',
        'pwa/module': 'module',
        'pwa/plugin': 'plugin',
        'pwa/view': 'view',
        'pwa/Application': 'Application',

        // pwa sources required from user_public sources
        '__original__/BookingUrlBuilder': '../../user_public/app/lib/view/BookingUrlBuilder',
        'lib/view/BookingUrlBuilder': 'lib/view/BookingUrlBuilder',

        //tickets
        'plugin/tickets/TicketsPlugin': 'plugin/tickets/TicketsPlugin',
        '__original__/TicketsPlugin': '../../user_public/app/plugin/tickets/TicketsPlugin',

        //step manager
        'controller/step/BookingStepManager': 'controller/step/BookingStepManager',
        '__original__/BookingStepManager': '../../user_public/app/controller/step/BookingStepManager',
        'controller/step/BookingRescheduleStepManager': 'controller/step/BookingRescheduleStepManager',
        '__original__/BookingRescheduleStepManager': '../../user_public/app/controller/step/BookingRescheduleStepManager',

        'lib/AppRouter': 'lib/AppRouter',

        'view/controller/booking/result/BookingResultItemView': 'view/controller/booking/result/BookingResultItemView',
        '__original__/BookingResultItemView': '../../user_public/app/view/controller/booking/result/BookingResultItemView',

        //client login
        'plugin/client-login/controller/ClientLoginController': 'plugin/client-login/controller/ClientLoginController',
        '__original__/ClientLoginController': '../../user_public/app/plugin/client-login/controller/ClientLoginController',
        'plugin/client-login/view/ClientLoginProfileView': 'plugin/client-login/view/ClientLoginProfileView',
        '__original__/ClientLoginProfileView': '../../user_public/app/plugin/client-login/view/ClientLoginProfileView',

        'view/layout/MainLayout': 'view/layout/MainLayout',
        '__original__/MainLayout': '../../user_public/app/view/layout/MainLayout',

        'plugin/additional-fields/view/AdditionalFieldItemView': 'plugin/additional-fields/view/AdditionalFieldItemView',
        '__original__/AdditionalFieldItemView': '../../user_public/app/plugin/additional-fields/view/AdditionalFieldItemView',

        //multiple booking
        'plugin/multiple-booking/MultipleBookingPlugin': 'plugin/multiple-booking/MultipleBookingPlugin',
        '__original__/MultipleBookingPlugin': '../../user_public/app/plugin/multiple-booking/MultipleBookingPlugin',
        'plugin/multiple-booking/view/MultipleBookingListView': 'plugin/multiple-booking/view/MultipleBookingListView',
        '__original__/MultipleBookingListView': '../../user_public/app/plugin/multiple-booking/view/MultipleBookingListView',

    },
    deps: [
        'marionette.handlebars', 'view/helper/TemplateHelper', 'view/helper/TemplatePartials', 'jquery', 'pwa', 'jquery.cookie', 'jquery.ui', 'jquery.ui.slider', 'jquery.ui.touch',
        'utils.locale', 'utils.date', 'utils.time', 'bootstrap', 'notification', 'ofi', 'bowser', 'promise', 'assign', /*'google.intl.phone',*/ 'google.intl.phone.init', 'qrcode'
    ],
    shim: {
        'view/helper/TemplatePartials': ['jquery'],
        'bootstrap': ['jquery'],
        'pwa': ['jquery'],
        'notification': ['jquery'],
        'jquery.cookie': ['jquery'],
        'cookieblock': ['jquery.cookie'],
        'jquery.ui': {
            'deps': ['jquery']
        },
        'jquery.ui.slider': {
            'deps': ['jquery', 'jquery.ui']
        },
        'jquery.ui.touch': {
            'deps': ['jquery', 'jquery.ui']
        },
        'utils.locale': {
            'deps': ['utils.string'],
            'exports': 'Locale'
        },
        'utils.time': {
            'deps': ['jquery', 'utils.locale'],
            'exports': 'Time'
        },
        'utils.date': {
            'deps': ['jquery', 'utils.locale']
        },
        'ofi': {
            'init': function () {
                objectFitImages();
            },
            'deps': ['jquery']
        },
        'google_adwords': {
            'exports': 'google_trackConversion'
        },
        'google_analytic': {
            'exports': 'ga'
        },
        'google_translate': {
            'exports': 'google_translate'
        },
        'line_liff': {
            'exports': 'liff'
        },
        //'google.intl.phone' : ['jquery' ],
        'google.intl.phone.init' : ['jquery',/*'google.intl.phone'*/ ]
    },
    generateSourceMaps: true,
    preserveLicenseComments: false,
    urlArgs: 'bust=' + (new Date()).getTime() // to not cache
});

requirejs(['pwa/Application', 'Config'], function (Application, Config) {
    // to make it visible for old date/time/locale utils
    window.Config = Config;

    requirejs.config({
        paths: {
            'ext': '/v2/themes/' + theme + '/js',
            'third-party-libs': '/v2/lib'
        }
    });

    var startApp = function (extPlugin) {
        var app = new Application({
            theme: theme,
            themeVars: themeVars,
            extPlugin: extPlugin
        });
        app.start();
    };
    requirejs(['ext/ExternalPluginsInitializer'], function (ExternalPluginsInitializer) {
        startApp(new ExternalPluginsInitializer());
    }, function () {
        startApp();
    });
});

define("../init", function(){});

